export default () => {
    const cartPage = document.querySelector('body.ordering-process');
    const emptyBasket = document.querySelector('.cart-empty')
    const cartContent = document.querySelector('.cart-content')

    if (cartPage) {
        if (emptyBasket) {
            console.log('empty basket')

            emptyBasket.insertAdjacentHTML('afterend', `
                 <div class="empty-basket text-center">
                    <a href="/" class="btn btn--primary">Homepage</a>
                 </div>
              `);
        }

        if (cartContent) {
            const basketWrapper = document.querySelector('#content-wrapper')
            const productVariant = $('.main-link-variant')

            basketWrapper.insertAdjacentHTML('afterbegin', `
                 <h1 class="basket-title">Nákupní košík</h1>
              `);

            if (productVariant.length) {
                productVariant.each(function() {
                    const textVariant = $(this).text()

                    const finallyText = textVariant.trim();
                    const priceProduct = $(this).closest('.removeable').find('.p-price')
                    console.log(finallyText)
                    const variant = $(`<td class="p-variant">${finallyText}</td>`)
                    variant.insertBefore(priceProduct)
                })


            }
        }
    }
};